import React from "react";
import styled from "styled-components";

const StyledCol = styled.div`
  ${(p) => p.inlineCSS && p.inlineCSS};
`;

const Col = ({ extra = {}, children = null }) => {
  const { cols = 12, style = {}, css, className = "" } = extra;

  return (
    <StyledCol
      inlineCSS={css}
      className={`${className} col-md-${cols} d-flex ${
        style.flexDirection ? `flex-${style.flexDirection}` : "flex-column"
      } ${style.alignItems ? `align-items-${style.alignItems}` : ""} ${
        style.justifyContent ? `justify-content-${style.justifyContent}` : ""
      } `}
    >
      {children}
    </StyledCol>
  );
};

export default Col;
